import styled, { keyframes } from 'styled-components'
import { theme } from '../../styles/theme'

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

export const Container = styled.div`
  width: 100%;
  height: 100%;

  background: ${theme.colors.white};

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const Loader = styled.div`
  border: 5px solid transparent;
  border-left-color: ${theme.colors.gray500};
  border-radius: 50%;

  width: 30px;
  height: 30px;

  position: absolute;
  bottom: 25px;

  animation: ${rotate} 1s linear infinite;
`
